<template>
  <div>
    <div class="row" >
      <div class="col-md-12">
        <h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2>
      </div>
    </div>
    <div class="row" >
      <div class="col-md-12">
        <employees-report-table :data="report" :projectId="currentProject"></employees-report-table>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {setCookie, url} from "../../plugins/axios";
    import EmployeesReportTable from "../Reports/EmployeesReportTable";

    export default {
      name: "EmployeesReports",
      components: {EmployeesReportTable},
      data(){
        return{
          currentProject: 0,
          projectName: '',
          report: {},
        }
      },
      methods:{
        getEmployeesReport(id){
          axios
            .get(url + 'employees-reports/'+id+'/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.report = response.data.result;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        }
      },
      created() {
        const params = this.$route.query;
        this.currentProject = params.projectId;
        this.projectName = params.projectName.split('_').join(' ');
        if (this.currentProject > 0){
          this.getEmployeesReport(this.currentProject);
        }
      }
    }
</script>

<style scoped>

</style>
